import React, { useCallback, useState } from 'react';
import { useParams } from 'react-router';

import { getHealthInsurances, HealthInsurancesModel, HealthInsurancesResult } from 'api/hs/health-insurances';
import { useAsyncEffect } from 'utils';

import { HealthInsurancesContext } from './health-insurances.context';
import HealthInsurances from './healthInsurances';

export default function Index() {
  const [healthInsurances, setHealthInsurances] = useState<HealthInsurancesResult[]>(null);
  const [loading, setLoading] = useState(null);
  const [newDialogOpened, setNewDialogOpened] = useState(false);
  const [editDialogOpened, setEditDialogOpened] = useState(false);
  const [selectedData, setSelectedData] = useState<HealthInsurancesModel>(null);
  const { employeeId } = useParams<{ employeeId: string }>();

  const fetch = useCallback(async () => {
    const result = await getHealthInsurances(employeeId);
    setHealthInsurances(result);
    setLoading(false);
  }, [employeeId]);

  useAsyncEffect(async () => {
    await fetch();
  }, []);

  return (
    <HealthInsurancesContext.Provider
      value={{
        healthInsurances,
        reload: fetch,
        loading,
        editDialogOpened,
        setEditDialogOpened,
        setLoading,
        newDialogOpened,
        setNewDialogOpened,
        selectedData,
        setSelectedData,
      }}>
      <HealthInsurances />
    </HealthInsurancesContext.Provider>
  );
}
